import React, { FC } from 'react'
import block from 'bem-cn'

import { ReactComponent as LoaderSvg } from 'shared/img/loader.svg'

import './Loader.scss'

type LoaderProps = {
  loaderWidth?: number
  loaderHeight?: number
  variant?: 'default' | 'svg'
}
const b = block('loader-component')

export const Loader: FC<LoaderProps> = ({ loaderHeight = 20, loaderWidth = 20, variant = 'default' }) => (
  <div className={b('container')}>
    {variant === 'svg' ? (
      <LoaderSvg className={b('icon')} style={{ width: loaderWidth, height: loaderHeight }} />
    ) : (
      <div className={b()} style={{ width: loaderWidth, height: loaderHeight }} />
    )}
  </div>
)
